import React, { useState, useEffect, useRef } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import styled from "styled-components";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PdfPage = () => {
  const url = localStorage.getItem("pdfId");

  const [numPages, setNumPages] = useState<number | null>(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [scale, setScale] = useState(1.4);
  const pagesRef = useRef<(HTMLDivElement | null)[]>([]);

  const nextPage = () => {
    if (pageNumber < (numPages ?? 1)) {
      setPageNumber((prev) => prev + 1);
    }
  };

  const prevPage = () => {
    if (pageNumber > 1) {
      setPageNumber((prev) => prev - 1);
    }
  };

  const zoomIn = () => setScale((prev) => prev + 0.2);
  const zoomOut = () => setScale((prev) => (prev > 0.6 ? prev - 0.2 : prev));

  useEffect(() => {
    if (pagesRef.current[pageNumber - 1]) {
      pagesRef.current[pageNumber - 1]?.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [pageNumber]);

  return (
    <DivStylePdfPage>
      <Toolbar>
        <button onClick={prevPage} disabled={pageNumber <= 1}>◀ Anterior</button>
        <span>Página {pageNumber} de {numPages ?? "..."}</span>
        <button onClick={nextPage} disabled={pageNumber >= (numPages ?? 1)}>Próxima ▶</button>

        <button onClick={zoomOut}>➖ Zoom Out</button>
        <button onClick={zoomIn}>➕ Zoom In</button>
      </Toolbar>

      <PdfContainer>
        <Document file={url} onLoadSuccess={({ numPages }) => setNumPages(numPages)}>
          {numPages &&
            Array.from({ length: numPages }, (_, index) => (
              <div key={index} ref={(el) => (pagesRef.current[index] = el)}>
                <Page
                  pageNumber={index + 1}
                  scale={scale}
                  className={pageNumber === index + 1 ? "active" : "inactive"}
                />
              </div>
            ))}
        </Document>
      </PdfContainer>
    </DivStylePdfPage>
  );
};

export default PdfPage;

const DivStylePdfPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #333;
  min-height: 100vh;
  width: 100%;
  padding: 20px;
  padding-top: 0px;
`;

const Toolbar = styled.div`
  display: flex;
  gap: 10px;
  background: #222;
  padding: 10px;
  width: 100%;
  justify-content: center;
  align-items: center;
  border-radius: 8px;
  position: fixed;
  z-index: 9;

  button {
    background: #555;
    color: white;
    border: none;
    padding: 8px 12px;
    cursor: pointer;
    border-radius: 5px;
  }

  button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  span {
    color: white;
    font-size: 16px;
  }
`;

const PdfContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  align-items: center;
  overflow-y: auto;
  margin-top: 65px;
`;
